(function () {
  'use strict';

  var STORAGE_KEY = 'dreadlocksCenterQuiz';
  var STATE_VERSION = 2;

  var PROJECT_OPTIONS = [
    {
      value: 'lengthen',
      title: 'Rallonger mes locks actuelles',
      description: 'Je veux conserver mes locks et gagner en longueur.'
    },
    {
      value: 'volume',
      title: 'Ajouter du volume',
      description: 'Je veux densifier ma coiffure ou compléter certaines zones.'
    },
    {
      value: 'full',
      title: 'Faire une pose complète',
      description: 'Je souhaite créer une coiffure complète avec des extensions.'
    },
    {
      value: 'micro',
      title: 'Créer ou rallonger des Micro Locks / Sisterlocks',
      description: 'Je recherche des extensions particulièrement fines.'
    }
  ];

  var RENDER_OPTIONS = [
    {
      value: 'classic',
      title: 'Locks naturelles classiques',
      description: 'Je veux des locks intemporelles, naturelles et polyvalentes.'
    },
    {
      value: 'curly',
      title: 'Locks bouclées / Curly',
      description: 'Je veux conserver un mouvement bouclé et davantage de volume.'
    },
    {
      value: 'texturees',
      title: 'Locks texturées effet mature',
      description: 'Je veux retrouver le grain et le relief de locks qui semblent déjà matures.'
    },
    {
      value: 'micro',
      title: 'Micro Locks / Sisterlocks',
      description: 'Je veux des locks extrêmement fines et légères.'
    },
    {
      value: 'poivre',
      title: 'Poivre et Sel',
      description: 'Je souhaite des extensions contenant naturellement des tons gris.'
    },
    {
      value: 'unknown',
      title: 'Je ne sais pas encore',
      description: 'Guide-moi vers le rendu qui correspond le mieux à mon projet.'
    }
  ];

  var HELP_OPTIONS = [
    { value: 'curly', title: 'Je veux conserver un rendu bouclé' },
    { value: 'micro', title: 'Je veux des extensions extrêmement fines' },
    { value: 'poivre', title: 'Je veux assortir des cheveux gris / poivre et sel' },
    { value: 'texturees', title: 'Je veux un effet très texturé et déjà mature' },
    { value: 'classic', title: 'Je veux simplement de belles locks naturelles classiques' }
  ];

  var FINISH_OPTIONS = [
    {
      value: 'arrondie',
      title: 'Finition Arrondie',
      description: 'Pour une pointe déjà fermée et arrondie et un résultat net et structuré.'
    },
    {
      value: 'interlock',
      title: 'Finition Interlock / Crochet',
      description: 'Pour choisir nos locks permanentes faites main au crochet avec finition Interlock.'
    },
    {
      value: 'unknown',
      title: 'Je ne connais pas la différence',
      description: 'Afficher une explication avant de choisir.'
    }
  ];

  var PRODUCT_LABELS = {
    arrondie: 'Locks Finition Arrondie',
    curly: 'Curly Locks',
    texturees: 'Locks Texturées',
    micro: 'Micro Locks',
    interlock: 'Finition Interlock',
    poivre: 'Poivre et Sel'
  };

  var STEP_ANSWERS = {
    project: 'project',
    render: 'render',
    help: 'help',
    conflict: 'conflict',
    finish: 'finish',
    thickness: 'thickness',
    length: 'length',
    quantity: 'requestedLocks'
  };

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function unique(values) {
    return values.filter(function (value, index, list) {
      return value != null && value !== '' && list.indexOf(value) === index;
    });
  }

  function dataLayerPush(name, payload) {
    if (!Array.isArray(window.dataLayer)) return;
    window.dataLayer.push(Object.assign({ event: name }, payload || {}));
  }

  function RecommendationEngine() {}

  RecommendationEngine.prototype.getBaseFamily = function (answers) {
    if (answers.render === 'unknown') return answers.help || null;
    return answers.render || null;
  };

  RecommendationEngine.prototype.needsConflict = function (answers) {
    var family = this.getBaseFamily(answers);
    return answers.project === 'micro' && family && family !== 'micro';
  };

  RecommendationEngine.prototype.getEffectiveFamily = function (answers) {
    var family = this.getBaseFamily(answers);
    if (!family) return null;
    if (!this.needsConflict(answers)) return family;
    if (answers.conflict === 'micro') return 'micro';
    if (answers.conflict === 'render') return family;
    return null;
  };

  RecommendationEngine.prototype.getProductKey = function (answers) {
    var family = this.getEffectiveFamily(answers);
    if (!family) return null;
    if (family === 'classic') {
      return answers.finish === 'arrondie' || answers.finish === 'interlock'
        ? answers.finish
        : null;
    }
    return ['curly', 'texturees', 'micro', 'poivre'].indexOf(family) > -1
      ? family
      : null;
  };

  function VariantResolver(product) {
    this.product = product;
    this.availableVariants = (product.variants || []).filter(function (variant) {
      return variant.available === true;
    });
    this.indices = this.findOptionIndices();
  }

  VariantResolver.prototype.findOptionIndices = function () {
    var names = this.product.optionNames || [];
    var indices = { thickness: -1, length: -1, quantity: -1 };
    names.forEach(function (name, index) {
      var normalized = normalize(name);
      if (normalized.indexOf('epaisseur') > -1) indices.thickness = index;
      if (normalized.indexOf('longueur') > -1) indices.length = index;
      if (normalized.indexOf('quantite') > -1) indices.quantity = index;
    });
    if (indices.thickness < 0 && names.length > 0) indices.thickness = 0;
    if (indices.length < 0 && names.length > 1) indices.length = 1;
    return indices;
  };

  VariantResolver.prototype.hasQuantityOption = function () {
    return this.indices.quantity > -1;
  };

  VariantResolver.prototype.filter = function (selection) {
    var indices = this.indices;
    return this.availableVariants.filter(function (variant) {
      if (selection.thickness && variant.options[indices.thickness] !== selection.thickness) return false;
      if (selection.length && variant.options[indices.length] !== selection.length) return false;
      if (selection.quantityOption && variant.options[indices.quantity] !== selection.quantityOption) return false;
      return true;
    });
  };

  VariantResolver.prototype.getThicknesses = function () {
    var index = this.indices.thickness;
    return unique(this.availableVariants.map(function (variant) {
      return variant.options[index];
    }));
  };

  VariantResolver.prototype.getLengths = function (thickness) {
    var index = this.indices.length;
    return unique(this.filter({ thickness: thickness }).map(function (variant) {
      return variant.options[index];
    }));
  };

  VariantResolver.prototype.getQuantityOptions = function (thickness, length) {
    if (!this.hasQuantityOption()) return [];
    var index = this.indices.quantity;
    return unique(this.filter({ thickness: thickness, length: length }).map(function (variant) {
      return variant.options[index];
    }));
  };

  VariantResolver.prototype.getPackOption = function (requestedLocks, thickness, length) {
    var target = Number(requestedLocks) === 100 ? 100 : 10;
    return this.getQuantityOptions(thickness, length).find(function (option) {
      var text = normalize(option);
      var match = target === 100
        ? /(^|\D)100(\D|$)/.test(text)
        : /(^|\D)10(\D|$)/.test(text) && !/(^|\D)100(\D|$)/.test(text);
      return match;
    }) || null;
  };

  VariantResolver.prototype.resolve = function (selection) {
    var cartQuantity = 1;
    var quantityOption = null;

    if (this.hasQuantityOption()) {
      var requested = Number(selection.requestedLocks);
      if (!requested || [10, 30, 40, 50, 60, 70, 100].indexOf(requested) < 0) {
        return { variant: null, cartQuantity: 0, quantityOption: null };
      }
      quantityOption = this.getPackOption(requested, selection.thickness, selection.length);
      if (!quantityOption) return { variant: null, cartQuantity: 0, quantityOption: null };
      cartQuantity = requested === 100 ? 1 : requested / 10;
    }

    var variants = this.filter({
      thickness: selection.thickness,
      length: selection.length,
      quantityOption: quantityOption
    });

    return {
      variant: variants.length === 1 ? variants[0] : null,
      cartQuantity: variants.length === 1 ? cartQuantity : 0,
      quantityOption: quantityOption
    };
  };

  VariantResolver.prototype.getRequestedLockChoices = function (thickness, length) {
    var resolver = this;
    if (!this.hasQuantityOption()) return [];
    return [10, 30, 40, 50, 60, 70, 100].filter(function (count) {
      return Boolean(resolver.resolve({
        thickness: thickness,
        length: length,
        requestedLocks: count
      }).variant);
    });
  };

  function LocksQuiz(root) {
    if (root.dataset.quizInitialized === 'true') return;
    root.dataset.quizInitialized = 'true';
    this.root = root;
    this.stage = root.querySelector('[data-quiz-stage]');
    this.status = root.querySelector('[data-quiz-status]');
    this.progress = root.querySelector('[data-quiz-progress]');
    this.progressBar = root.querySelector('[data-quiz-progress-bar]');
    this.progressLabel = root.querySelector('[data-quiz-progress-label]');
    this.progressValue = root.querySelector('[data-quiz-progress-value]');
    this.engine = new RecommendationEngine();
    this.products = {};
    this.config = null;
    this.state = this.loadState();
    this.onClick = this.handleClick.bind(this);
    this.root.addEventListener('click', this.onClick);
    this.initializeProducts();
    this.root.dreadQuizController = this;
    this.render();
  }

  LocksQuiz.prototype.initializeProducts = function () {
    var script = this.root.querySelector('[data-locks-quiz-products]');
    try {
      this.config = JSON.parse(script.textContent);
      (this.config.products || []).forEach(function (product) {
        if (product && product.key) this.products[product.key] = product;
      }, this);
    } catch (error) {
      this.config = { currency: 'EUR', moneyFormat: '{{amount_with_comma_separator}} €', products: [] };
    }
  };

  LocksQuiz.prototype.emptyState = function () {
    return {
      version: STATE_VERSION,
      step: 'project',
      history: [],
      answers: {},
      trackedProduct: null,
      trackedCompletion: null
    };
  };

  LocksQuiz.prototype.loadState = function () {
    try {
      var parsed = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY));
      if (parsed && parsed.version === STATE_VERSION && parsed.answers && parsed.step) return parsed;
    } catch (error) {
      /* sessionStorage can be blocked; the in-memory state remains sufficient. */
    }
    return this.emptyState();
  };

  LocksQuiz.prototype.saveState = function () {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(this.state));
    } catch (error) {
      /* Keep the quiz usable when storage is unavailable. */
    }
  };

  LocksQuiz.prototype.getProductKey = function () {
    return this.engine.getProductKey(this.state.answers);
  };

  LocksQuiz.prototype.getProduct = function () {
    return this.products[this.getProductKey()] || null;
  };

  LocksQuiz.prototype.getResolver = function () {
    var product = this.getProduct();
    return product && product.exists ? new VariantResolver(product) : null;
  };

  LocksQuiz.prototype.clearAfter = function (step) {
    var answerOrder = ['project', 'render', 'help', 'conflict', 'finish', 'thickness', 'length', 'requestedLocks'];
    var key = STEP_ANSWERS[step];
    var start = answerOrder.indexOf(key);
    if (start < 0) return;
    for (var index = start + 1; index < answerOrder.length; index += 1) {
      delete this.state.answers[answerOrder[index]];
    }
    this.state.trackedProduct = null;
    this.state.trackedCompletion = null;
  };

  LocksQuiz.prototype.setAnswer = function (step, value) {
    var key = STEP_ANSWERS[step];
    if (!key) return;
    var parsedValue = step === 'quantity' && value !== 'unknown' ? Number(value) : value;
    if (this.state.answers[key] !== parsedValue) this.clearAfter(step);
    this.state.answers[key] = parsedValue;
    this.saveState();
    this.render();
    var selected = Array.prototype.find.call(
      this.root.querySelectorAll('[data-option-value]'),
      function (button) { return button.dataset.optionValue === String(value); }
    );
    if (selected) selected.focus({ preventScroll: true });
  };

  LocksQuiz.prototype.markStarted = function () {
    if (this.state.started) return;
    this.state.started = true;
    this.saveState();
    dataLayerPush('locks_quiz_started');
  };

  LocksQuiz.prototype.nextAfterFamily = function () {
    var answers = this.state.answers;
    if (this.engine.needsConflict(answers) && !answers.conflict) return 'conflict';
    return this.engine.getEffectiveFamily(answers) === 'classic' ? 'finish' : 'thickness';
  };

  LocksQuiz.prototype.nextStep = function (step) {
    if (step === 'project') return 'render';
    if (step === 'render') return this.state.answers.render === 'unknown' ? 'help' : this.nextAfterFamily();
    if (step === 'help' || step === 'conflict') return this.nextAfterFamily();
    if (step === 'finish') return 'thickness';
    if (step === 'thickness') return 'length';
    if (step === 'length') {
      var resolver = this.getResolver();
      return resolver && resolver.hasQuantityOption() ? 'quantity' : 'result';
    }
    if (step === 'quantity') return 'result';
    return null;
  };

  LocksQuiz.prototype.isStepValid = function (step) {
    var answers = this.state.answers;
    var value = answers[STEP_ANSWERS[step]];
    if (step === 'finish') return value === 'arrondie' || value === 'interlock';
    if (step === 'quantity') return value === 'unknown' || [10, 30, 40, 50, 60, 70, 100].indexOf(Number(value)) > -1;
    return value !== undefined && value !== null && value !== '';
  };

  LocksQuiz.prototype.goNext = function () {
    var step = this.state.step;
    if (!this.isStepValid(step)) {
      var validation = this.root.querySelector('[data-quiz-validation]');
      if (validation) {
        validation.textContent = step === 'finish' && this.state.answers.finish === 'unknown'
          ? 'Choisis la finition que tu préfères après avoir lu les explications.'
          : 'Sélectionne une réponse avant de continuer.';
        validation.focus({ preventScroll: true });
      }
      return;
    }

    var next = this.nextStep(step);
    if (!next) return;
    if (next === 'thickness') {
      var productKey = this.getProductKey();
      var product = this.products[productKey];
      if (!product || !product.exists) {
        this.renderFatal('Le produit recommandé est introuvable dans Shopify. Réessaie ou consulte la collection Extensions.');
        return;
      }
      if (this.state.trackedProduct !== productKey) {
        dataLayerPush('locks_quiz_product_recommended', {
          product_handle: product.handle,
          product_id: product.id
        });
        this.state.trackedProduct = productKey;
      }
    }

    dataLayerPush('locks_quiz_step_completed', {
      quiz_step: step,
      product_handle: this.getProduct() ? this.getProduct().handle : undefined
    });
    this.state.history.push(step);
    this.state.step = next;
    this.saveState();
    this.render();
    this.focusCurrentHeading();
  };

  LocksQuiz.prototype.goBack = function () {
    var previous = this.state.history.pop();
    if (!previous) return;
    this.state.step = previous;
    this.saveState();
    this.render();
    this.focusCurrentHeading();
  };

  LocksQuiz.prototype.restart = function () {
    try { window.sessionStorage.removeItem(STORAGE_KEY); } catch (error) { /* no-op */ }
    this.state = this.emptyState();
    this.render();
    this.focusCurrentHeading();
  };

  LocksQuiz.prototype.focusCurrentHeading = function () {
    var heading = this.root.querySelector('[data-quiz-heading]');
    if (!heading) return;
    window.requestAnimationFrame(function () {
      heading.focus({ preventScroll: true });
      heading.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  };

  LocksQuiz.prototype.getFlow = function () {
    var answers = this.state.answers;
    var flow = ['project', 'render'];
    if (answers.render === 'unknown') flow.push('help');
    if (this.engine.needsConflict(answers)) flow.push('conflict');
    if (this.engine.getEffectiveFamily(answers) === 'classic') flow.push('finish');
    var productKey = this.getProductKey();
    if (productKey) {
      flow.push('thickness', 'length');
      var product = this.products[productKey];
      if (product && product.exists && new VariantResolver(product).hasQuantityOption()) flow.push('quantity');
      flow.push('result');
    } else if (flow.indexOf(this.state.step) < 0) {
      flow.push(this.state.step);
    }
    return flow;
  };

  LocksQuiz.prototype.updateProgress = function () {
    var flow = this.getFlow();
    var current = Math.max(0, flow.indexOf(this.state.step));
    var total = Math.max(flow.length, this.getProductKey() ? flow.length : 7);
    var percent = this.state.step === 'result' ? 100 : Math.round((current / Math.max(1, total - 1)) * 100);
    this.progress.setAttribute('aria-valuenow', String(percent));
    this.progressBar.style.width = percent + '%';
    this.progressValue.textContent = percent + ' %';
    this.progressLabel.textContent = this.state.step === 'result'
      ? 'Résultat'
      : 'Étape ' + (current + 1) + ' sur ' + Math.max(1, total - 1);
  };

  LocksQuiz.prototype.renderChoice = function (option, selected, compact) {
    var description = option.description
      ? '<span class="dread-locks-quiz__choice-description">' + escapeHtml(option.description) + '</span>'
      : '';
    return '<button type="button" class="dread-locks-quiz__choice' + (compact ? ' dread-locks-quiz__choice--value' : '') + '"' +
      ' data-option-value="' + escapeHtml(option.value) + '" aria-pressed="' + (selected ? 'true' : 'false') + '">' +
      '<span class="dread-locks-quiz__choice-mark" aria-hidden="true">' + (selected ? '✓' : '') + '</span>' +
      '<span class="dread-locks-quiz__choice-copy">' +
      '<span class="dread-locks-quiz__choice-title">' + escapeHtml(option.title) + '</span>' + description +
      '</span></button>';
  };

  LocksQuiz.prototype.getStepContent = function (step) {
    var answers = this.state.answers;
    var resolver = this.getResolver();
    var family = this.engine.getBaseFamily(answers);
    var content = { kicker: 'Ton projet', title: '', lead: '', options: [], compact: false, info: '' };

    if (step === 'project') {
      content.title = 'Quel est ton projet ?';
      content.lead = 'Choisis la situation qui correspond le mieux à ton besoin actuel.';
      content.options = PROJECT_OPTIONS;
    } else if (step === 'render') {
      content.kicker = 'Le rendu';
      content.title = 'Quel rendu recherches-tu ?';
      content.lead = 'Ce choix détermine la famille d’extensions à explorer.';
      content.options = RENDER_OPTIONS;
    } else if (step === 'help') {
      content.kicker = 'Aide au choix';
      content.title = 'Qu’est-ce qui ressemble le plus au résultat que tu veux obtenir ?';
      content.options = HELP_OPTIONS;
    } else if (step === 'conflict') {
      content.kicker = 'Vérification';
      content.title = 'Quel résultat souhaites-tu privilégier ?';
      content.lead = 'Tu avais indiqué rechercher des Micro Locks, mais tu viens de sélectionner ' +
        (family === 'curly' ? 'Curly Locks' : family === 'texturees' ? 'des Locks Texturées' : family === 'poivre' ? 'Poivre et Sel' : 'des Locks classiques') + '.';
      content.options = [
        { value: 'micro', title: 'Privilégier mes Micro Locks', description: 'Continuer avec les extensions particulièrement fines.' },
        { value: 'render', title: 'Privilégier mon dernier choix', description: 'Continuer avec le rendu sélectionné à l’étape précédente.' }
      ];
    } else if (step === 'finish') {
      content.kicker = 'La finition';
      content.title = 'Quelle finition préfères-tu ?';
      content.options = FINISH_OPTIONS;
      if (answers.finish === 'unknown') {
        content.info = '<strong>Finition Arrondie</strong> Pour une pointe déjà fermée et arrondie et un résultat net et structuré.' +
          '<br><br><strong>Finition Interlock / Crochet</strong> Pour choisir nos locks permanentes faites main au crochet avec finition Interlock.' +
          '<br><br>Sélectionne maintenant la finition que tu préfères pour continuer.';
      }
    } else if (step === 'thickness') {
      content.kicker = PRODUCT_LABELS[this.getProductKey()] || 'La configuration';
      content.title = 'Quelle épaisseur souhaites-tu ?';
      content.lead = 'Seules les épaisseurs menant à une variante disponible sont proposées.';
      content.compact = true;
      content.options = (resolver ? resolver.getThicknesses() : []).map(function (value) {
        return { value: value, title: value };
      });
    } else if (step === 'length') {
      content.kicker = 'La longueur';
      content.title = 'Quelle longueur souhaites-tu ?';
      content.lead = 'Ces longueurs sont compatibles avec l’épaisseur ' + (answers.thickness || '') + '.';
      content.compact = true;
      content.options = (resolver ? resolver.getLengths(answers.thickness) : []).map(function (value) {
        return { value: value, title: value };
      });
    } else if (step === 'quantity') {
      content.kicker = 'La quantité';
      content.title = 'De combien de locks as-tu besoin ?';
      content.lead = 'Le quiz utilisera automatiquement le bon conditionnement Shopify et le bon nombre de lots.';
      content.compact = true;
      var counts = resolver ? resolver.getRequestedLockChoices(answers.thickness, answers.length) : [];
      content.options = counts.map(function (value) {
        return { value: String(value), title: value + ' locks' };
      });
      content.options.push({ value: 'unknown', title: 'Je ne sais pas' });
    }

    return content;
  };

  LocksQuiz.prototype.renderStep = function (step) {
    var content = this.getStepContent(step);
    if (!content.options.length) {
      this.renderFatal('Aucune variante disponible ne correspond aux choix actuels. Reviens à l’étape précédente pour modifier ta sélection.');
      return;
    }
    var selected = this.state.answers[STEP_ANSWERS[step]];
    var choices = content.options.map(function (option) {
      return this.renderChoice(option, String(selected) === String(option.value), content.compact);
    }, this).join('');
    var info = content.info ? '<div class="dread-locks-quiz__info">' + content.info + '</div>' : '';
    var backDisabled = this.state.history.length ? '' : ' disabled';

    this.stage.innerHTML = '<div class="dread-locks-quiz__step" data-current-step="' + escapeHtml(step) + '">' +
      '<div class="dread-locks-quiz__step-head">' +
      '<p class="dread-locks-quiz__step-kicker">' + escapeHtml(content.kicker) + '</p>' +
      '<h2 data-quiz-heading tabindex="-1">' + escapeHtml(content.title) + '</h2>' +
      (content.lead ? '<p class="dread-locks-quiz__step-lead">' + escapeHtml(content.lead) + '</p>' : '') +
      '</div>' +
      '<div class="dread-locks-quiz__choices' + (content.compact ? ' dread-locks-quiz__choices--compact' : '') + '" role="group" aria-label="' + escapeHtml(content.title) + '">' + choices + '</div>' +
      info +
      '<p class="dread-locks-quiz__validation" data-quiz-validation tabindex="-1" aria-live="assertive"></p>' +
      '<div class="dread-locks-quiz__nav">' +
      '<button type="button" class="dread-locks-quiz__button dread-locks-quiz__button--text" data-quiz-restart>Recommencer</button>' +
      '<div class="dread-locks-quiz__nav-group">' +
      '<button type="button" class="dread-locks-quiz__button" data-quiz-back' + backDisabled + '>Retour</button>' +
      '<button type="button" class="dread-locks-quiz__button dread-locks-quiz__button--primary" data-quiz-next>Suivant →</button>' +
      '</div></div></div>';
  };

  LocksQuiz.prototype.formatMoney = function (cents) {
    var moneyFormat = this.config && this.config.moneyFormat;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: (this.config && this.config.currency) || 'EUR'
      }).format(Number(cents) / 100);
    } catch (error) {
      return (Number(cents) / 100).toFixed(2) + ' ' + ((this.config && this.config.currency) || 'EUR');
    }
  };

  LocksQuiz.prototype.getReasons = function () {
    var answers = this.state.answers;
    var reasons = [];
    var projectReason = {
      lengthen: 'tu souhaites rallonger tes locks actuelles',
      volume: 'tu souhaites ajouter du volume',
      full: 'tu prépares une pose complète',
      micro: 'tu recherches des Micro Locks ou Sisterlocks'
    }[answers.project];
    var renderReason = {
      classic: 'tu recherches un rendu de locks naturelles classiques',
      curly: 'tu recherches un rendu bouclé',
      texturees: 'tu recherches un effet texturé et mature',
      micro: 'tu recherches des extensions particulièrement fines',
      poivre: 'tu souhaites des tons poivre et sel'
    }[this.engine.getEffectiveFamily(answers)];
    if (projectReason) reasons.push(projectReason);
    if (renderReason) reasons.push(renderReason);
    if (answers.thickness) reasons.push('tu as choisi une épaisseur de ' + answers.thickness);
    if (answers.length) reasons.push('tu as choisi une longueur de ' + answers.length);
    if (Number(answers.requestedLocks)) reasons.push('tu souhaites ' + answers.requestedLocks + ' locks');
    return reasons;
  };

  LocksQuiz.prototype.resultSignature = function (product, variant, requestedLocks) {
    return [product.handle, variant ? variant.id : 'none', requestedLocks || 'none'].join('|');
  };

  LocksQuiz.prototype.renderResult = function () {
    var product = this.getProduct();
    var resolver = this.getResolver();
    if (!product || !resolver) {
      this.renderFatal('Le produit recommandé est indisponible dans Shopify. Recommence le quiz ou consulte la collection Extensions.');
      return;
    }

    var answers = this.state.answers;
    var resolution = resolver.resolve(answers);
    var variant = resolution.variant;
    var needsQuantity = resolver.hasQuantityOption() && answers.requestedLocks === 'unknown';
    var quantityChoices = resolver.getRequestedLockChoices(answers.thickness, answers.length);
    var image = variant && variant.image ? variant.image : product.image;
    var resultUrl = variant ? product.url + '?variant=' + encodeURIComponent(variant.id) : product.url;
    var price = variant ? this.formatMoney(Number(variant.price) * resolution.cartQuantity) : '';
    var summary = [
      ['Type', PRODUCT_LABELS[product.key] || product.title],
      ['Épaisseur', answers.thickness],
      ['Longueur', answers.length]
    ];
    if (resolver.hasQuantityOption()) {
      summary.push(['Quantité', Number(answers.requestedLocks) ? answers.requestedLocks + ' locks' : 'À choisir']);
    }
    var summaryHtml = summary.map(function (item) {
      return '<div><dt>' + escapeHtml(item[0]) + '</dt><dd>' + escapeHtml(item[1]) + '</dd></div>';
    }).join('');
    var reasons = this.getReasons().map(function (reason) {
      return '<li>' + escapeHtml(reason) + '</li>';
    }).join('');
    var quantityHelp = needsQuantity
      ? '<div class="dread-locks-quiz__quantity-help">' +
        '<h3>Besoin d’aide pour la quantité ?</h3>' +
        '<p>Le nombre exact dépend notamment du projet, de la densité souhaitée, du diamètre choisi et de la coiffure existante. Choisis une quantité avant l’ajout au panier.</p>' +
        '<div class="dread-locks-quiz__quantity-buttons" role="group" aria-label="Choisir la quantité de locks">' +
        quantityChoices.map(function (count) {
          return '<button type="button" class="dread-locks-quiz__button" data-result-quantity="' + count + '">' + count + ' locks</button>';
        }).join('') + '</div></div>'
      : '';
    var exactError = !needsQuantity && !variant
      ? '<p class="dread-locks-quiz__cart-message is-error">Aucune variante disponible ne correspond exactement à cette configuration. Modifie l’une de tes réponses.</p>'
      : '<p class="dread-locks-quiz__cart-message" data-cart-message aria-live="polite"></p>';
    var disabled = variant ? '' : ' disabled';
    var productLink = variant
      ? '<a class="dread-locks-quiz__button" href="' + escapeHtml(resultUrl) + '">Voir mes locks</a>'
      : '<a class="dread-locks-quiz__button" href="' + escapeHtml(product.url) + '">Voir le produit</a>';

    this.stage.innerHTML = '<div class="dread-locks-quiz__result" data-result-product="' + escapeHtml(product.key) + '"' +
      (variant ? ' data-result-variant-id="' + escapeHtml(variant.id) + '" data-result-cart-quantity="' + resolution.cartQuantity + '"' : '') + '>' +
      '<div class="dread-locks-quiz__result-grid">' +
      '<div class="dread-locks-quiz__result-media">' +
      (image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" width="960" height="1200" loading="eager">' : '') +
      '</div>' +
      '<div class="dread-locks-quiz__result-copy">' +
      '<p class="dread-locks-quiz__result-kicker">Ta recommandation</p>' +
      '<h2 data-quiz-heading tabindex="-1">Tes locks idéales</h2>' +
      '<p class="dread-locks-quiz__result-product">' + escapeHtml(product.title) + '</p>' +
      '<ul class="dread-locks-quiz__reasons" aria-label="Pourquoi ce choix">' + reasons + '</ul>' +
      '<dl class="dread-locks-quiz__summary">' + summaryHtml + '</dl>' +
      (variant ? '<p class="dread-locks-quiz__price">' + escapeHtml(price) + '</p>' : '') +
      quantityHelp +
      '<div class="dread-locks-quiz__result-actions">' +
      '<button type="button" class="dread-locks-quiz__button dread-locks-quiz__button--primary" data-quiz-add' + disabled + '>Ajouter ma sélection au panier</button>' +
      productLink + '</div>' + exactError +
      '<div class="dread-locks-quiz__result-tools">' +
      '<button type="button" class="dread-locks-quiz__button dread-locks-quiz__button--text" data-quiz-back>Modifier ma sélection</button>' +
      '<button type="button" class="dread-locks-quiz__button dread-locks-quiz__button--text" data-quiz-restart>Recommencer le quiz</button>' +
      '</div></div></div></div>';

    if (variant) {
      var signature = this.resultSignature(product, variant, answers.requestedLocks);
      if (this.state.trackedCompletion !== signature) {
        dataLayerPush('locks_quiz_completed', {
          product_handle: product.handle,
          product_id: product.id,
          variant_id: variant.id,
          thickness: answers.thickness,
          length: answers.length,
          requested_locks_count: Number(answers.requestedLocks) || undefined
        });
        this.state.trackedCompletion = signature;
        this.saveState();
      }
    }
  };

  LocksQuiz.prototype.renderFatal = function (message) {
    this.stage.innerHTML = '<div class="dread-locks-quiz__fatal" role="alert">' + escapeHtml(message) +
      '<div class="dread-locks-quiz__result-tools"><button type="button" class="dread-locks-quiz__button" data-quiz-back>Retour</button>' +
      '<button type="button" class="dread-locks-quiz__button" data-quiz-restart>Recommencer</button></div></div>';
  };

  LocksQuiz.prototype.render = function () {
    this.updateProgress();
    if (this.state.step === 'result') this.renderResult();
    else this.renderStep(this.state.step);
  };

  LocksQuiz.prototype.updateThemeCart = function (cart) {
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
    if (count !== null) {
      var selectors = '[data-cart-count], [data-cart-item-count], .t4s-count-box';
      document.querySelectorAll(selectors).forEach(function (node) {
        node.textContent = String(count);
        node.setAttribute('data-count', String(count));
      });
    }

    var detail = { cart: cart, open: true, source: 'locks-quiz' };
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: detail }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: detail }));
    if (window.jQuery_T4NT) window.jQuery_T4NT(document).trigger('cart:updated', [cart]);

    window.setTimeout(function () {
      var opener = document.querySelector(
        '[data-drawer-options*="t4s-mini_cart"], [data-drawer-options*="mini_cart"], [data-open-drawer="cart"], [data-cart-drawer-trigger]'
      );
      if (opener && opener.getAttribute('aria-expanded') !== 'true') opener.click();
    }, 180);
  };

  LocksQuiz.prototype.addToCart = async function (button) {
    var product = this.getProduct();
    var resolver = this.getResolver();
    var resolution = resolver ? resolver.resolve(this.state.answers) : null;
    var message = this.root.querySelector('[data-cart-message]');
    if (!product || !resolution || !resolution.variant || !resolution.variant.available) {
      if (message) {
        message.className = 'dread-locks-quiz__cart-message is-error';
        message.textContent = 'Cette variante ne peut pas être ajoutée. Modifie ta sélection.';
      }
      return;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    var originalText = button.textContent;
    button.textContent = 'Ajout en cours…';
    if (message) message.textContent = '';

    try {
      var rootRoute = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
      var response = await fetch(rootRoute + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(resolution.variant.id), quantity: resolution.cartQuantity }]
        })
      });
      var result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Ajout au panier impossible.');
      var cartResponse = await fetch(rootRoute + 'cart.js', { headers: { Accept: 'application/json' } });
      var cart = cartResponse.ok ? await cartResponse.json() : null;
      this.updateThemeCart(cart);
      dataLayerPush('locks_quiz_add_to_cart', {
        product_handle: product.handle,
        product_id: product.id,
        variant_id: resolution.variant.id,
        thickness: this.state.answers.thickness,
        length: this.state.answers.length,
        requested_locks_count: Number(this.state.answers.requestedLocks) || undefined
      });
      if (message) {
        message.className = 'dread-locks-quiz__cart-message is-success';
        message.innerHTML = 'Ta sélection a été ajoutée. <a href="' + escapeHtml(rootRoute + 'cart') + '">Voir le panier</a>.';
      }
      button.textContent = 'Ajouté au panier ✓';
    } catch (error) {
      if (message) {
        message.className = 'dread-locks-quiz__cart-message is-error';
        message.textContent = error && error.message
          ? error.message
          : 'Une erreur est survenue. Réessaie dans un instant.';
      }
      button.disabled = false;
      button.textContent = originalText;
    } finally {
      button.removeAttribute('aria-busy');
    }
  };

  LocksQuiz.prototype.handleClick = function (event) {
    var option = event.target.closest('[data-option-value]');
    if (option && this.root.contains(option)) {
      this.markStarted();
      this.setAnswer(this.state.step, option.dataset.optionValue);
      return;
    }

    var resultQuantity = event.target.closest('[data-result-quantity]');
    if (resultQuantity && this.root.contains(resultQuantity)) {
      this.state.answers.requestedLocks = Number(resultQuantity.dataset.resultQuantity);
      this.state.trackedCompletion = null;
      this.saveState();
      this.render();
      var addButton = this.root.querySelector('[data-quiz-add]');
      if (addButton) addButton.focus({ preventScroll: true });
      return;
    }

    var next = event.target.closest('[data-quiz-next]');
    if (next && this.root.contains(next)) {
      this.goNext();
      return;
    }

    var back = event.target.closest('[data-quiz-back]');
    if (back && this.root.contains(back) && !back.disabled) {
      this.goBack();
      return;
    }

    var restart = event.target.closest('[data-quiz-restart]');
    if (restart && this.root.contains(restart)) {
      this.restart();
      return;
    }

    var add = event.target.closest('[data-quiz-add]');
    if (add && this.root.contains(add) && !add.disabled) this.addToCart(add);
  };

  function boot(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-locks-quiz]').forEach(function (root) {
      new LocksQuiz(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();

